import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private translations: { [lang: string]: any } = {};

  constructor(private httpclient: HttpClient) { 
    const en = localStorage.getItem('translations-en');
    const ar = localStorage.getItem('translations-ar');

    if (en) this.translations['en'] = JSON.parse(en);
    if (ar) this.translations['ar'] = JSON.parse(ar);
  }

  loadTranslationsFromApi(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.httpclient.post(environment.appUrl + '/api/Translation/GetTranslationFile',{}).subscribe({
        next: (res: any) => {
          if (res?.Result['TransaltionEn']) this.setTranslations('en', res['Result']['TransaltionEn']);
          if (res?.Result['TransaltionAr']) this.setTranslations('ar', res['Result']['TransaltionAr']);
          resolve();
        },
        error: (err) => {
          console.error('Translation API error:', err);
          resolve(); // resolve anyway so app can continue
        }
      });
    });
  }
 

  setTranslations(lang: 'en' | 'ar', data: any): void {
    this.translations[lang] = data;
    localStorage.setItem(`translations-${lang}`, JSON.stringify(data));
  }

  // get(key: string): string {
  //   return this.translations[this.currentLang]?.[key] ?? key;
  // }

  getAll(): any {
    return this.translations || {};
  }

}
